module.exports = __webpack_public_path__ + "static/media/check.45704885.svg";